module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-6df5b93e.png";